import mainnetTokens from "../../constants/tokens/mainnet.json";
import mumbaiTokens from "../../constants/tokens/mumbai.json";

export const tokensList: Record<number, any> = {
  137: mainnetTokens,
  80001: mumbaiTokens,
};
